export default "__VITE_ASSET__1a157489__"